import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MeWork from "./pages/MeWork/MeWork";
import Publications from "./pages/Publications/Publications";
import Gigging from "./pages/Gigging/Gigging";
import Models from "./pages/Models/Models";
import Sumly from "./pages/Sumly/Sumly";
import MeLife from "./pages/MeLife/MeLife";
import DevCentral from "./pages/DevCentral/DevCentral";
import Connect from "./pages/Connect/Connect";
import DigitalProducts from "./pages/digital-products/DigitalProducts";
import Ebooks from "./pages/digital-products/ebooks/Ebooks";
import SalesPage from "./pages/digital-products/ebooks/one-person-ten-people/SalesPage";
import reportWebVitals from "./reportWebVitals";

import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { AudioProvider } from "./components/AudioProvider";
import CustomCursor from "./components/CustomCursor";

function AppShell() {
  return (
    <>
      <CustomCursor />
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      {
        path: "/",
        element: <MeWork />,
      },
      {
        path: "/publications",
        element: <Publications />,
      },
      {
        path: "gigging",
        element: <Gigging />,
      },
      {
        path: "models",
        element: <Models />,
      },
      {
        path: "sumly",
        element: <Sumly />,
      },
      {
        path: "sumly/:feature",
        element: <Sumly />,
      },
      {
        path: "connect",
        element: <Connect />,
      },
      {
        path: "me_life",
        element: <MeLife />,
      },
      {
        path: "devcentral",
        element: <DevCentral />,
      },
      {
        path: "digital-products",
        element: <DigitalProducts />,
      },
      {
        path: "digital-products/ebooks",
        element: <Ebooks />,
      },
      {
        path: "digital-products/ebooks/one-person-ten-people",
        element: <SalesPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AudioProvider>
      <RouterProvider router={router} />
    </AudioProvider>
  </React.StrictMode>
);

reportWebVitals();
